const ConnectedAccountSettings: React.FC = () => {
  return <div>Connected Account Settings</div>
}

export default ConnectedAccountSettings
